import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function TakeQuiz() {
  const { id } = useParams();
  const [quiz, setQuiz] = useState(null);
  const [name, setName] = useState("");
  const [key, setKey] = useState("");
  const [showQuiz, setShowQuiz] = useState(false);
  const [answers, setAnswers] = useState({});

  useEffect(() => {
    if (showQuiz && key !== "") {
      fetch(`https://yesedacademy.com/database/quiz.php?action=get&quiz_id=${id}&key=${key}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.error) {
            alert(data.error);
            setShowQuiz(false);
          } else {
            setQuiz(data);
          }
        });
    }
  }, [showQuiz]);

  const handleSubmit = () => {
    const payload = {
      quiz_id: id,
      name,
      answers: JSON.stringify(answers),
    };
    fetch("https://yesedacademy.com/database/quiz.php?action=submit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.text())
      .then((res) => alert(res));
  };

  if (!showQuiz) {
    return (
      <div className="p-6 max-w-md mx-auto bg-white rounded-xl shadow-md space-y-4">
        <input
          className="border p-2 w-full"
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          className="border p-2 w-full"
          placeholder="Validation Key"
          value={key}
          onChange={(e) => setKey(e.target.value)}
        />
        <button
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
          onClick={() => setShowQuiz(true)}
        >
          Start Quiz
        </button>
      </div>
    );
  }

  if (!quiz) return <div className="text-center mt-10">Loading quiz...</div>;

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">{quiz.title}</h2>
      {quiz.questions.map((q, index) => (
        <div key={q.id} className="mb-4">
          <p className="font-semibold mb-2">{index + 1}. {q.text}</p>
          {q.options.map((opt, i) => (
            <label key={i} className="block">
              <input
                type="radio"
                name={`q_${q.id}`}
                value={opt}
                onChange={(e) =>
                  setAnswers({ ...answers, [q.id]: e.target.value })
                }
              />{' '}{opt}
            </label>
          ))}
        </div>
      ))}
      <button
        className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
        onClick={handleSubmit}
      >
        Submit Answers
      </button>
    </div>
  );
}